import { LogoIcon } from '@/landing/components/Icons/LogoIcon/LogoIcon';
import CoFounders from '@/public/images/jakub-founder.jpg';
import styles from './Farewell.module.scss';

export const Farewell = () => (
  <section className={styles.farewell}>
    <div className={styles.container}>
      <LogoIcon width={142} height={22} />

      <h1 className={styles.heading}>Dziękuję za wspólną naukę.</h1>

      <hr className={styles.divider} />

      <p className={styles.body}>
        Nerdbord kończy działalność. Przez ponad 3 lata
        przeszkoliliśmy razem ponad 1000 programistów i programistek w
        budowaniu produktów cyfrowych. To była niesamowita przygoda —
        dziękuję, że był_ś jej częścią.
      </p>

      <div className={styles.author}>
        <div className={styles.avatarWrapper}>
          <img src={CoFounders.src} alt="Jakub Wąsowski" />
        </div>
        <p className={styles.name}>Jakub Wąsowski</p>
        <p className={styles.role}>Twórca Nerdborda</p>
      </div>

      <div className={styles.links}>
        <a
          href="https://www.linkedin.com/in/jwasowski"
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.link} ${styles.linkPrimary}`}
        >
          LinkedIn
        </a>
        <a
          href="https://wasowski.tech"
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.link} ${styles.linkSecondary}`}
        >
          wasowski.tech
        </a>
      </div>

      <p className={styles.footer}>
        &copy; {new Date().getFullYear()} Nerdbord
      </p>
    </div>
  </section>
);
